export default __webpack_public_path__ + "static/media/1wash-flyers.417bf56b.png";